import React, { Dispatch, SetStateAction } from 'react';
import DENTModalOverviewSubButtonsSelection from '../DENTModalOverviewSubButtonsSelection/DENTModalOverviewSubButtonsSelection';
import {
	ToothEndodonticTest,
	ToothEndodonticTestResult,
	ToothEndodonticTestResultNotApplicable,
	ToothEndodonticTestResultPositive,
} from '../../../../graphql/graphql';

interface Props {
	values?: ToothEndodonticTest;
	onChange: (value: ToothEndodonticTest) => void;
}

const DENTModalOverviewGeneralEndodonticTemperatureButtons = ({
	values,
	onChange,
}: Props) => {
	const handleChangeResult = (value: ToothEndodonticTestResult) => {
		onChange({
			result: values?.result === value ? undefined : value,
			resultPositive: undefined,
			resultNotApplicable: undefined,
		});
	};

	const handleChangeResultPositive = (
		value: ToothEndodonticTestResultPositive,
	) => {
		onChange({
			...values,
			resultPositive: values?.resultPositive === value ? undefined : value,
			resultNotApplicable: undefined,
		});
	};

	const handleChangeResultNotApplicable = (
		value: ToothEndodonticTestResultNotApplicable,
	) => {
		onChange({
			...values,
			resultPositive: undefined,
			resultNotApplicable:
				values?.resultNotApplicable === value ? undefined : value,
		});
	};

	const rows = [
		{
			shouldHide: false,
			items: [
				{
					title: 'patientTreatment.meddiDENT.dentalCross.endodontic.positive',
					isSelected: values?.result === ToothEndodonticTestResult.Positive,
					onClick: () => handleChangeResult(ToothEndodonticTestResult.Positive),
				},
				{
					title: 'patientTreatment.meddiDENT.dentalCross.endodontic.uncertain',
					isSelected: values?.result === ToothEndodonticTestResult.Uncertain,
					onClick: () =>
						handleChangeResult(ToothEndodonticTestResult.Uncertain),
				},
				{
					title: 'patientTreatment.meddiDENT.dentalCross.endodontic.negative',
					isSelected: values?.result === ToothEndodonticTestResult.Negative,
					onClick: () => handleChangeResult(ToothEndodonticTestResult.Negative),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.endodontic.notApplicable',
					isSelected:
						values?.result === ToothEndodonticTestResult.NotApplicable,
					onClick: () =>
						handleChangeResult(ToothEndodonticTestResult.NotApplicable),
				},
			],
		},
		{
			shouldHide: values?.result !== ToothEndodonticTestResult.Positive,
			items: [
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.endodontic.withinLimits',
					isSelected:
						values?.resultPositive ===
						ToothEndodonticTestResultPositive.WithinLimits,
					onClick: () =>
						handleChangeResultPositive(
							ToothEndodonticTestResultPositive.WithinLimits,
						),
				},
				{
					title: 'patientTreatment.meddiDENT.dentalCross.endodontic.unpleasant',
					isSelected:
						values?.resultPositive ===
						ToothEndodonticTestResultPositive.Unpleasant,
					onClick: () =>
						handleChangeResultPositive(
							ToothEndodonticTestResultPositive.Unpleasant,
						),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.endodontic.painStimulus',
					isSelected:
						values?.resultPositive ===
						ToothEndodonticTestResultPositive.PainStimulus,
					onClick: () =>
						handleChangeResultPositive(
							ToothEndodonticTestResultPositive.PainStimulus,
						),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.endodontic.painLingering',
					isSelected:
						values?.resultPositive ===
						ToothEndodonticTestResultPositive.PainLingering,
					onClick: () =>
						handleChangeResultPositive(
							ToothEndodonticTestResultPositive.PainLingering,
						),
				},
			],
		},
		{
			shouldHide: values?.result !== ToothEndodonticTestResult.NotApplicable,
			items: [
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.endodontic.existingRootCanalTreatment',
					isSelected:
						values?.resultNotApplicable ===
						ToothEndodonticTestResultNotApplicable.ExistingRootCanalTreatment,
					onClick: () =>
						handleChangeResultNotApplicable(
							ToothEndodonticTestResultNotApplicable.ExistingRootCanalTreatment,
						),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.endodontic.previouslyInitiatedTherapy',
					isSelected:
						values?.resultNotApplicable ===
						ToothEndodonticTestResultNotApplicable.PreviouslyInitiatedTherapy,
					onClick: () =>
						handleChangeResultNotApplicable(
							ToothEndodonticTestResultNotApplicable.PreviouslyInitiatedTherapy,
						),
				},
			],
		},
	];

	return <DENTModalOverviewSubButtonsSelection rows={rows} />;
};

export default DENTModalOverviewGeneralEndodonticTemperatureButtons;
